import React, { Fragment } from "react";
import { toast } from "react-toastify";

const OrderItem = ({ data, index, setUpdate }) => {
  const pendingHandler = () => {
    fetch(`https://itghar-back.onrender.com/order/${data.trxID}`, {
      method: "PUT",

      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
      .then((response) => {
        if (response?.status === 404 || response?.status === 403) {
          toast.error("Order Not Found");
        }

        return response.json();
      })
      .then((json) => {
        if (json?.status) {
          toast.success("SuccessFully");
          setUpdate(true);
        } else {
          toast.error(json?.error);
        }
      });
  };

  return (
    <Fragment>
      <tbody>
        <tr>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            <p className="text-gray-600 whitespace-no-wrap">{index + 1}</p>
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            {data.courseType}
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            {data.contactNo}
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            <span className="relative inline-block px-3 py-1 font-semibold  cursor-pointer leading-tight">
              {data.trxID}
            </span>
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            <button
              onClick={pendingHandler}
              className="bg-linear-gradient py-2 px-2 rounded-lg text-[#fff] text-sm font-semibold"
            >
              Pending
            </button>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};

export default OrderItem;
